import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * 페이지 전환 시 스크롤을 맨 위로 이동시키는 컴포넌트
 * React Router의 경로 변경을 감지하여 자동으로 스크롤 위치를 초기화합니다.
 * 모바일 포함 모든 해상도에서 동작하도록 window/documentElement/body 모두 초기화하고,
 * 새 화면 렌더 후 실행되도록 requestAnimationFrame을 사용합니다.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollToZero = () => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      if (document.documentElement) document.documentElement.scrollTop = 0;
      if (document.body) document.body.scrollTop = 0;
    };

    // 즉시 한 번 실행
    scrollToZero();

    // 새 라우트 렌더/레이아웃 후 다시 실행 (모바일에서 스크롤 컨테이너가 늦게 적용되는 경우 대비)
    const rafId = requestAnimationFrame(() => {
      scrollToZero();
      requestAnimationFrame(scrollToZero);
    });

    return () => cancelAnimationFrame(rafId);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
